import { render, staticRenderFns } from "./campos-alterados.vue?vue&type=template&id=101a90b3&scoped=true"
import script from "./campos-alterados.vue?vue&type=script&lang=js"
export * from "./campos-alterados.vue?vue&type=script&lang=js"
import style0 from "./campos-alterados.vue?vue&type=style&index=0&id=101a90b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a90b3",
  null
  
)

export default component.exports